export default __webpack_public_path__ + "static/media/farm_challenge_water_salinity.a9b22802.jpg";